export const formatCurrency = (integerPart: number, fractionalPart: number = 0) =>
    new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: fractionalPart ? 2 : 0,
    }).format(fractionalPart ? Number(`${integerPart}.${fractionalPart}`) : integerPart);
